var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEsignGatewayNotify = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 104,
  height: 105,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 52.693,
  r: 52,
  fill: "#B7D523"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M52.056 28.453a16 16 0 0 0-16 16v7.707a12.74 12.74 0 0 1-1.52 5.493l-3.066 5.093a5.118 5.118 0 0 0 2.88 7.814 55.8 55.8 0 0 0 35.386 0 5.333 5.333 0 0 0 2.88-7.814l-3.066-5.093a13.1 13.1 0 0 1-1.494-5.493v-7.707a16.05 16.05 0 0 0-16-16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M56.984 29.228a16 16 0 0 0-2.56-.534 18 18 0 0 0-7.306.534 5.3 5.3 0 0 1 9.866 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 4,
  d: "M60.053 71.52a8.024 8.024 0 0 1-8 8 8.03 8.03 0 0 1-5.654-2.347 8.03 8.03 0 0 1-2.346-5.654"
})));
export { SvgEsignGatewayNotify as ReactComponent };
export default __webpack_public_path__ + "403a537a15a879beb4d36b07cefc5375.svg";